<template>
  <b-form-group
    label="Kode Register Barang"
    label-for="kodeRegisterBarang"
    label-class="pb-0 pt-0"
  >
    <b-form-input
      v-model="kodeRegisterBarang"
      disabled
    />
  </b-form-group>
</template>
<script>
export default {
  props: {
    kodeRegisterBarang: { type: String, default: '' },
  },
}
</script>
